/* Founders Studio quick add. Adds from product cards without leaving the page, then updates the header count and opens the bag (with its install upgrade and order bump). No app. Safe in Instagram and Facebook browsers. */
(function(){
  var CFG = window.FS_QA || {};
  function closest(el, sel){ return el && el.closest ? el.closest(sel) : null; }
  function all(sel, r){ return Array.prototype.slice.call((r || document).querySelectorAll(sel)); }

  function closeAll(except){
    all('[data-x-qa-pick]:not([hidden])').forEach(function(p){
      if (p === except) return;
      p.hidden = true;
      var w = closest(p, '[data-x-qa]'), t = w && w.querySelector('[data-x-qa-toggle]'), card = closest(p, '.x-pc');
      if (t) t.setAttribute('aria-expanded', 'false');
      if (card) card.classList.remove('is-qa-open');
    });
  }

  function open(t){
    var w = closest(t, '[data-x-qa]'), p = w && w.querySelector('[data-x-qa-pick]'), card = closest(t, '.x-pc');
    if (!p) return;
    var on = p.hidden;
    closeAll(on ? p : null);
    if (!on){ p.hidden = true; t.setAttribute('aria-expanded', 'false'); if (card) card.classList.remove('is-qa-open'); return; }
    if (card) { p.style.setProperty('--x-qa-w', card.offsetWidth + 'px'); card.classList.add('is-qa-open'); }
    p.hidden = false; t.setAttribute('aria-expanded', 'true');
    var first = p.querySelector('.x-qa-opt'); if (first) setTimeout(function(){ try { first.focus({ preventScroll: true }); } catch(e){ first.focus(); } }, 30);
  }

  function post(url, data){
    return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(data) })
      .then(function(r){ return r.json().then(function(j){ if (!r.ok) throw j; return j; }); });
  }

  function add(btn){
    var id = +btn.getAttribute('data-x-qa-add'); if (!id) return;
    var w = closest(btn, '[data-x-qa]'), main = w && w.querySelector('.x-qa-btn');
    var opt = btn.classList.contains('x-qa-opt');
    btn.classList.add('is-busy'); if (main && opt) main.classList.add('is-busy');
    post('/cart/add.js', { items: [{ id: id, quantity: 1 }] })
      .then(function(){ return fetch('/cart.js').then(function(r){ return r.json(); }); })
      .then(function(cart){
        btn.classList.remove('is-busy');
        if (main){ main.classList.remove('is-busy'); main.classList.add('is-added'); setTimeout(function(){ main.classList.remove('is-added'); }, 1800); }
        closeAll();
        try { window.dispatchEvent(new CustomEvent('vs:cart:updated', { detail: cart })); } catch(e){}
        all('.nav-bag-count,[data-x-bag-count-badge]').forEach(function(b){ b.textContent = cart.item_count; b.style.display = cart.item_count ? '' : 'none'; });
        if (CFG.openBag !== false && window.VS_DRAWER && window.VS_DRAWER.open) setTimeout(function(){ window.VS_DRAWER.open(); }, 350);
      })
      .catch(function(){
        btn.classList.remove('is-busy');
        if (main){ main.classList.remove('is-busy'); main.classList.add('is-error'); setTimeout(function(){ main.classList.remove('is-error'); }, 1800); }
      });
  }

  document.addEventListener('click', function(e){
    var t = closest(e.target, '[data-x-qa-toggle]');
    if (t){ e.preventDefault(); e.stopPropagation(); open(t); return; }
    var a = closest(e.target, '[data-x-qa-add]');
    if (a){ e.preventDefault(); e.stopPropagation(); add(a); return; }
    if (closest(e.target, '[data-x-qa-close]')){ e.preventDefault(); closeAll(); return; }
    if (!closest(e.target, '[data-x-qa-pick]')) closeAll();
  });
  document.addEventListener('keydown', function(e){
    if (e.key !== 'Escape') return;
    var p = document.querySelector('[data-x-qa-pick]:not([hidden])'); if (!p) return;
    var t = closest(p, '[data-x-qa]').querySelector('[data-x-qa-toggle]');
    closeAll(); if (t) t.focus();
  });
  /* Sit the button at the bottom right of the product image, so sticky bars never cover it. Falls back to top right if this does not run. */
  function place(){
    all('[data-x-qa]').forEach(function(w){
      var card = closest(w, '.x-pc'), fig = card && card.querySelector('figure');
      if (!fig || !fig.offsetHeight) return;
      var gap = window.innerWidth <= 900 ? 8 : 12;
      w.style.bottom = Math.max(0, card.offsetHeight - fig.offsetTop - fig.offsetHeight + gap) + 'px';
      w.classList.add('is-low');
      card.classList.add('has-qa');
    });
  }
  function watch(){
    try { place(); } catch(e){}
    if ('ResizeObserver' in window){ try { var ro = new ResizeObserver(function(){ try { place(); } catch(e){} }); all('.x-pc').forEach(function(c){ ro.observe(c); }); } catch(e){} }
    window.addEventListener('resize', function(){ try { place(); } catch(e){} });
    window.addEventListener('load', function(){ try { place(); } catch(e){} });
    setTimeout(function(){ try { place(); } catch(e){} }, 2500);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watch); else watch();
  document.addEventListener('shopify:section:load', function(){ try { place(); } catch(e){} });
})();
